export const timePickerStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		gap: '12px',
		alignItems: 'flex-end',
	} as any,

	content: {
		maxWidth: '100px',
		width: '100%',
	},

	time: {
		'& > div': {
			paddingLeft: '12px',
		},
		'& .MuiInputBase-root .MuiInputBase-input': {
			padding: 0,
		},
	},

	timeDisabled: {
		'& > div': {
			'& fieldset': {
				border: '1px solid var(--neutral-100)',
			},

		},
		'& .MuiInputBase-root:hover': {
			'& fieldset': {
				border: '1px solid var(--neutral-100)',
			},
	},},

	timeValid: {
		'& > div:hover:not(.Mui-disabled)': {
			'& fieldset': {
				border: '1px solid var(--primary-500) !important',
				borderRadius: '8px',
			},
		},

		'& input:focus': {
			color: 'var(--primary-500)',
		},

		'& .MuiInputBase-root:hover': {
			'& input': {
				color: 'var(--primary-500)',
				'&::placeholder': {
					opacity: 1,
					color: 'var(--primary-500) !important',
				},
			},
			'& fieldset': {
				border: '1px solid var(--primary-500)',
			},
		},
	},

	timeError: {
		'& svg path': {
			fill: 'var(--error-500)',
		},
	},

	meridiem: {
		maxWidth: '100px',
		width: '100%',

		'& .MuiFormControl-root .MuiInputBase-root:hover:not(.Mui-disabled)': {
			'& fieldset': {
				border: '1px solid var(--primary-500)',
			},
		},
	},

	meridiemSelect: {
		padding: '0	!important',
	},
};
